<template>
  <div class="animated">
    <v-server-table
      v-if="collection"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      id="invoice-server-table"
      class="w-100"
      :ref="this.ref">

<!--      <div slot="beforeTable" class="pt-3">-->
<!--        <b-row>-->
<!--          <b-col>-->
<!--            <select-filter-->
<!--              variant="info"-->
<!--              icon="fa-toggle-on"-->
<!--              placeholder="All Active/Inactive"-->
<!--              :list="filter__active"-->
<!--              filter-field="inactive"-->
<!--              filter-operator="eq"-->
<!--              @onSelect="setCustomFilter('customer__active', $event)"-->
<!--            ></select-filter>-->
<!--          </b-col>-->
<!--          <b-col>-->
<!--            <select-filter-->
<!--              variant="info"-->
<!--              icon="fa-map-marker"-->
<!--              placeholder="All Cities"-->
<!--              :list="filter__cities"-->
<!--              filter-field="primary_billing_location.city"-->
<!--              filter-operator="eq"-->
<!--              @onSelect="setCustomFilter('customer__cities', $event)"-->
<!--            ></select-filter>-->
<!--          </b-col>-->
<!--          <b-col>-->
<!--            <select-filter-->
<!--              variant="info"-->
<!--              icon="fa-map-marker"-->
<!--              placeholder="All Provinces/States"-->
<!--              :list="filter__provinces"-->
<!--              filter-field="primary_billing_location.region"-->
<!--              filter-operator="eq"-->
<!--              @onSelect="setCustomFilter('filter__provinces', $event)"-->
<!--            ></select-filter>-->
<!--          </b-col>-->
<!--          <b-col>-->
<!--            <select-filter-->
<!--              variant="info"-->
<!--              icon="fa-toggle-on"-->
<!--              placeholder="Credit/No-Credit"-->
<!--              :list="filter__credit"-->
<!--              filter-field="credit"-->
<!--              filter-operator="eq"-->
<!--              @onSelect="setCustomFilter('customer__credit', $event)"-->
<!--            ></select-filter>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </div>-->

      <span v-if="showColumn('created_at')" slot="created_at" slot-scope="{row}">
        <router-link :to="'/orders/'+row.id"><b>{{row.created_at | moment("MMMM Do YYYY")}}</b></router-link>
      </span>

      <span v-if="showColumn('customer.name')" slot="customer.name" slot-scope="{row}">
        <router-link :to="'/customers/'+row.getCustomer().id"><b>{{row.getCustomer().name}}</b></router-link>
      </span>

      <span v-if="showColumn('invoice_items')" slot="invoice_items" slot-scope="{row}">
        {{ row.invoice_items.length }}
      </span>

      <span v-if="showColumn('total')" slot="total" slot-scope="{row}">
        ${{ getTotal(row) }}
      </span>

<!--      <span v-if="showColumn('actions')" slot="actions" slot-scope="{row}">-->
<!--        <b-button variant="info" class="px-1 py-0 mr-1 text-white" :to="'/customer/'+(row.id)">-->
<!--          <i class="fa fa-eye"></i>-->
<!--        </b-button>-->
<!--        <b-button variant="warning" class="px-1 py-0 mr-1 text-white" :to="'/customer/'+(row.id)+'/edit'">-->
<!--          <i class="fa fa-pencil"></i>-->
<!--        </b-button>-->
<!--        <b-button variant="danger" class="px-1 py-0 mr-1 text-white" v-on:click="showDeleteModal(row.id)">-->
<!--          <i class="fa fa-trash"></i>-->
<!--        </b-button>-->
<!--      </span>-->

    </v-server-table>
  </div>
</template>

<script>
  import Vue from 'vue';
  import BaseServerTable from "@/components/shared/BaseServerTable";
  import _ from 'lodash';
  import {ServerTable} from 'vue-tables-2';
  import SelectFilter from "@/components/shared/SelectFilter";
  import InvoiceCollection from "../../../collections/cashier/InvoiceCollection";

  Vue.use(ServerTable);

  export default {
    name: 'InvoiceServerTable',
    extends: BaseServerTable,
    components: {
      ServerTable,
      SelectFilter
    },
    props: {
      collection: {
        type: Object,
        default: function () {
          return new InvoiceCollection();
        }
      },
      /** Column display whitelist rows */
      show_columns: {
        type: Array,
        default: function () {
          return [
            'created_at',
            'customer.name',
            'invoice_items',
            'total'
          ]
        }
      },
      filterable: {
        type: Array,
        default: function () {
          return [
            'created_at',
            'customer.name',
            'invoice_items',
            'total'
          ]
        }
      },
      sortable: {
        type: Array,
        default: function () {
          return [
            'created_at',
            'customer.name',
            'invoice_items',
            'total'
          ]
        }
      }
    },
    data: function () {
      return {
        table_config: _.merge(
          this.getDefaultTableConfig(), {
            options: {
              headings: {
                'created_at': 'Submitted On',
                'customer.name': 'Customer',
                'invoice_items': 'Line Items',
                'total': 'Total'
              }
            }
          }
        ),
      }
    },
    methods: {
      prepareCollectionFilter(filter) {
        filter.sortAddDesc('created_at', true);
        return filter;
      },

      getTotal(row) {
        return row.invoice_items.reduce((acc, item) => {
          return acc + (parseFloat(item.amount) / 100 || 0)
        }, 0).toFixed(2)
      }
    },
    mounted() {}
  }
  ;
</script>
